"use client";

import dynamic from "next/dynamic";

const CertificatesLoader = dynamic(() => import("./CertificatesSlider"), {
  ssr: false,
});

export default function CertificatesSliderWrapper({ cmsData }: { cmsData?: any }) {
  return <CertificatesLoader cmsData={cmsData} />;
}
